export default __webpack_public_path__ + "static/media/333bf1f82cd3c3c46584796a46f5d1bd.svg";